'use client';

import React from 'react';
import styles from '../styles/Home.module.css';
import { resolveDashboardUrls } from '../lib/appConfig';

export default function Page() {
  const { teacherUrl, studentUrl } = resolveDashboardUrls();

  return (
    <main className={styles.hero} data-lk-theme="default">
      <div className={styles.card}>
        <div className={styles.badge}>SubSchool Calls</div>
        <h1>Calls hub for teachers and students</h1>
        <p className={styles.lead}>
          You are on the SubSchool Calls home. To join or start a lesson, head to your dashboard:
          pick the teacher or student portal and launch your call from there.
        </p>
        <div className={styles.actions}>
          <a className={`${styles.button} ${styles.primary}`} href={teacherUrl}>
            Go to Teacher Dashboard
          </a>
          <a className={`${styles.button} ${styles.secondary}`} href={studentUrl}>
            Go to Student Dashboard
          </a>
        </div>
      </div>
    </main>
  );
}
